import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import en from './translations/en';
import zh from './translations/zh';
import ko from './translations/ko';
import ja from './translations/ja';
import es from './translations/es';
import vi from './translations/vi';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
  en: {
    translation: en,
  },
  zh: {
    translation: zh,
  },
  ja: {
    translation: ja,
  },
  vi: {
    translation: vi,
  },
  es: {
    translation: es,
  },
  ko: {
    translation: ko,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en',

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;



// WEBPACK FOOTER //
// /src/configuration/i18n.js